import { Grid } from "@material-ui/core";

/**
 * ProjectInfoBanner
 *
 * Displays the Project ID and Project Name at the top of lender request forms.
 * Renders nothing if neither value is available.
 *
 * Props:
 *   projectId   {string|number} — The project's public identifier (from the URL / route params)
 *   projectName {string}        — The project name from the project profile
 */
const ProjectInfoBanner = ({ projectId, projectName }) => {
  if (!projectId && !projectName) return null;

  return (
    <Grid
      item
      xs={12}
      style={{
        width: "100%",
        padding: "10px 0 14px",
        marginBottom: "16px",
        borderBottom: "1px solid #e6e8ed",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "30px",
          color: "#555",
          fontSize: "14px",
        }}
      >
        {projectId && (
          <span>
            <strong>Project ID:&nbsp;</strong>
            {projectId}
          </span>
        )}
        {projectName && (
          <span>
            <strong>Project:&nbsp;</strong>
            {projectName}
          </span>
        )}
      </div>
    </Grid>
  );
};

export default ProjectInfoBanner;
